<template>
    <div class="left-cnt">
        <form class="form-search" @submit.stop.prevent="searchTour">
            <the-mask
                :disabled="utils.isCooperator()"
                :mask="['######-###']"
                masked="masked"
                v-model="searchText"
                name
                class="form-control search-tour"
                placeholder="XXXXXX-XXX"
                value
            />
            <button class="btn btn-search-cir" type="formSubmit" :disabled="utils.isCooperator()">
                <i class="icon-search-w"></i>
            </button>
        </form>
        <slot />
    </div>
</template>

<script>
import router from "@/router";

import { TheMask } from "vue-the-mask";

import Utils from "@/helpers/utils";
import { Constants } from "@/helpers/constants";

import StorageService from "@/services/common/storage.service";
import TourService from "@/services/module/tour.service";
import { AuthService } from "@/services/common/auth.service";

export default {
    name: "PCTourInfo",
    components: {
        TheMask,
    },
    props: {
        groupType: "",
        listVouchers: { type: Function },
        setErrorMessage: { type: Function },
        updateTourInfo: { type: Function },
    },
    data () {
        return {
            utils: Utils,
            searchText: "",
            tourInfo: {},
            isClosed: 0,
        };
    },
    beforeMount () {
        let tourID = this.$route.query.search;
        if (tourID) {
            this.searchText = tourID;
        } else {
            let tourInfo = JSON.parse(StorageService.getTour());
            if (tourInfo && tourInfo.tour_number) {
                this.searchText = tourInfo.tour_number;
            }
        }
    },
    methods: {
        reSearchTour (closeTour) {
            this.searchText = closeTour;
            this.isClosed = 1;
            return this.getTourInfo();
        },
        searchTour () {
            if ((this.groupType && this.groupType.id < 5) || this.groupType == Constants.GroupVoucherType.travel_contract) {
                this.getTourInfo();
                StorageService.clearPreInputVoucher();
            } else {
                if (this.searchText == this.$route.query.search) {
                    this.$emit("updateSameTour");
                } else {
                    router.push("/tour/after-input?search=" + this.searchText);
                }
            }
        },
        getTourInfo () {
            TourService.getTour(this.searchText, this.isClosed).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                }
                if (response.status != 200) {
                    this.listVouchers();
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        this.setErrorMessage(
                            this.$root.$t("error.error_code_" + errorCode)
                        );
                    }
                    if (response.status == 404) {
                        this.$emit("closedTour", this.searchText);
                    }
                    this.tourInfo = {};
                    this.updateTourInfo(this.tourInfo);
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.setErrorMessage("");
                        this.tourInfo = response.data;
                        this.listVouchers();
                        this.updateTourInfo(this.tourInfo);
                    } else {
                        this.listVouchers();
                        this.updateTourInfo(this.tourInfo);
                        this.setErrorMessage("");
                        this.tourInfo = {};
                    }
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/pc/Tour/Search.vue